import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
  Message, Button, Icon, Form,
} from 'semantic-ui-react';
import { reduxForm, FieldArray } from 'redux-form';
import { withRouter, Link } from 'react-router-dom';
import APP_PATH from '../../constants/paths';

import RenderRow from './EditVehicleFieldRow';
import ViewOrRemoveAttachments from './ViewOrRemoveAttachments';

class EditExternalVehicleBatch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitError: '',
      submitSuccess: '',
    };
  }

  static onKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  handleDismiss = () => {
    this.setState({
      submitSuccess: '',
      submitError: '',
    });
  };

  static handleSubmit(event) {
    event.preventDefault();
  }

  render() {
    const {
      externalVehicles,
      onApproveHandler,
      onRejectHandler,
      onUpdateHandler,
      externalVehicleDocuments,
    } = this.props;

    const { submitError, submitSuccess } = this.state;

    const rowProps = {
      onApproveHandler,
      onRejectHandler,
      onUpdateHandler,
    };
    const batchId = externalVehicles && externalVehicles[0]
      ? externalVehicles[0].externalVehiclesBatchId
      : 0;
    const batch = {
      externalVehicleDocuments,
    };

    return (
      <div>
        <h2>Network+ Vehicles for Batch - {batchId}</h2>
        <Link
          to={{
            pathname: APP_PATH.EXTERNAL_VEHICLE_BATCHES,
            state: { refreshSearch: false },
          }}
        >
          <Button color='yellow' style={{ float: 'right', marginTop: '-3%' }}>
            Back
          </Button>
        </Link>

        <br />
        {/* <h4>Import Data: (XLSX,XLS,CSV)</h4> */}
        <h4>
          Upload Documentation &nbsp;&nbsp;
          <Button
            icon
            size='mini'
            color='grey'
            labelPosition='left'
          >
            <Icon name='file' /> Add Document
          </Button>
        </h4>

        {externalVehicleDocuments && <ViewOrRemoveAttachments batch={batch} />}

        <br />
        {submitError && (
          <Message
            error
            content={submitError}
            onDismiss={this.handleDismiss}
          />
        )}
        {submitSuccess && (
          <Message
            positive
            content={submitSuccess}
            onDismiss={this.handleDismiss}
          />
        )}
        <Form onSubmit={EditExternalVehicleBatch.handleSubmit} onKeyPress={EditExternalVehicleBatch.onKeyPress}>
          <FieldArray name='vehicles' component={RenderRow} props={rowProps} />
        </Form>
      </div>
    );
  }
}

EditExternalVehicleBatch.propTypes = {
  externalVehicles: PropTypes.arrayOf(PropTypes.shape({
    externalVehiclesBatchId: PropTypes.number,
  })),
  onApproveHandler: PropTypes.func.isRequired,
  onRejectHandler: PropTypes.func.isRequired,
  onUpdateHandler: PropTypes.func.isRequired,
  externalVehicleDocuments: PropTypes.arrayOf(PropTypes.object),
};

EditExternalVehicleBatch.defaultProps = {
  externalVehicles: [],
  externalVehicleDocuments: [],
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const existingVehicles = { vehicles: ownProps.externalVehicles };
  return {
    initialValues: existingVehicles,
  };
};

export default compose(
  withRouter,
  connect(null, mapDispatchToProps),
  reduxForm({
    form: 'npEditForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    enableReinitialize: true,
  })
)(EditExternalVehicleBatch);
